import { useQuery } from '@tanstack/react-query';

import { dictionaryTypes } from '../types';

import { dictionaryApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getRefuseReasons = (
  viewMode: dictionaryTypes.ViewMode
): Promise<dictionaryApiTypes.ListRefuseReasonsResponse> => {
  return axios.get('/refuse-reasons', { params: { viewMode } });
};

type QueryFnType = typeof getRefuseReasons;

type UseGetRefuseReasonsOptions = {
  viewMode: dictionaryTypes.ViewMode;
  config?: QueryConfig<QueryFnType>;
};

export const useGetRefuseReasons = ({ viewMode, config = {} }: UseGetRefuseReasonsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    // Opt out of the global refetchOnMount: false. Archive/restore invalidate
    // both viewMode keys, but only the mounted one is refetched — the other is
    // just marked stale and would be served from cache on the next mount.
    refetchOnMount: true,
    ...config,
    queryKey: ['refuse-reasons', viewMode],
    queryFn: () => getRefuseReasons(viewMode),
  });
};
